import {RSHistoryHelper} from './history';


export class RSUrlHelper
{
	/**
	 * @param {string} url
	 * @returns {string}
	 */
	static getBaseUrlWithUrl(url)
	{
		const u = new URL(url);

		return `${u.protocol}//${u.host}`;
	}


	/**
	 * @param {string} url
	 * @returns {string}
	 */
	static getUriWithUrl(url)
	{
		const u = new URL(url);

		return u.pathname;
	}
	
	
	/**
	 * @returns {string}
	 */
	static getUriString()
	{
		return window.location.pathname;
	}
	
	
	/**
	 * @param url
	 * @returns {string}
	 */
	static getUrlWithoutParametersWithUrl(url)
	{
		return RSUrlHelper.getBaseUrlWithUrl(url) + RSUrlHelper.getUriWithUrl(url);
	}
	


	/**
	 * @returns {Object}
	 */
	static getUriVariables()
	{
		let vars = {};
		let urlParameters = window.location.search;

		if ((typeof urlParameters !== 'undefined') && (urlParameters !== null) && (urlParameters !== '') && (urlParameters.substr(0, 1) === '?') && (urlParameters.length > 1))
		{
			urlParameters = urlParameters.substr(1).split('&');

			if (Array.isArray(urlParameters))
			{
				for (const urlParameter of urlParameters)
				{
					let splitted = urlParameter.split('=');
					vars[splitted[0]] = (splitted.length === 2) ? decodeURIComponent(splitted[1]) : '';

					splitted = null;
				}
			}
		}

		return (Object.keys(vars).length > 0) ? vars : null;
	}


	/**
	 * @param {string} index
	 * @returns {?string}
	 */
	static getUriVariable(index)
	{
		const vars = RSUrlHelper.getUriVariables();

		if ((vars != null) && (typeof vars[index] !== 'undefined'))
		{
			return vars[index];
		}

		return null;
	}


	/**
	 *
	 */
	static removeUriVariables()
	{
		//window.history.pushState({}, document.title, window.location.pathname);
		RSHistoryHelper.pushState(document.title, window.location.pathname);
	}


	/**
	 * @returns {string[]}
	 */
	static getUriSegments()
	{
		const segments = window.location.pathname.split('/');

		return segments.filter((e) => { return e });
	}


	/**
	 * @param {number} index
	 * @returns {?string}
	 */
	static getUriSegment(index)
	{
		const segments = RSUrlHelper.getUriSegments();

		return ((segments.length > 0) && (index > 0) && (index <= segments.length)) ? segments[(index - 1)] : null;
	}


	/**
	 * @param {string} url
	 * @returns {string[]}
	 */
	static getUriSegmentsWithUrl(url)
	{
		const u = new URL(url);
		const segments = u.pathname.split('/');

		return segments.filter((e) => { return e });
	}
	
	
	/**
	 * @returns {string}
	 */
	static getUrlParameters()
	{
		const urlParameters = window.location.search;
		
		if ((typeof urlParameters !== 'undefined') && (urlParameters !== null) && (urlParameters !== ''))
		{
			return (urlParameters.substr(0, 1) === '?') ? urlParameters : `?${urlParameters}`;
		}
		
		return '';
	}
	
	
	/**
	 * @param {Object} object
	 * @param {boolean} removeSquareBracketsInKeys
	 * @returns {string}
	 */
	static getUrlParametersWithObject(object, removeSquareBracketsInKeys = false)
	{
		const parameters = [];
		
		for (let [key, value] of Object.entries(object))
		{
			if (removeSquareBracketsInKeys && key.includes('[]'))
			{
				key = key.replaceAll('[]', '');
			}
			
			if ((value !== null) && (value !== ''))
			{
				if (Array.isArray(value))
				{
					value = value
						.filter(entry => {
							return (entry !== '');
						})
						.join(',');
					
					if (value === '') continue;
				}
				
				parameters.push(`${key}=${encodeURIComponent(value)}`);
			}
		}
		
		return (parameters.length > 0) ? `?${parameters.join('&')}` : '';
	}
	
	
	/**
	 * @param {string} url
	 * @param {Object} posts
	 */
	static redirectWithPosts(url, posts)
	{
		const elForm = document.createElement('form');
		elForm.setAttribute('action', url);
		elForm.setAttribute('method', 'post');
		
		for (const [key, value] of Object.entries(posts))
		{
			const elInput = document.createElement('input');
			elInput.setAttribute('name', key);
			elInput.setAttribute('type', 'hidden');
			elInput.setAttribute('value', value);
			
			elForm.appendChild(elInput);
		}

		document.body.appendChild(elForm);

		elForm.submit();
	}
}
